import { Component, computed, inject, input } from '@angular/core';
import { ModalService } from '@card-software/library';
import { TranslateService } from '@ngx-translate/core';
import { PoReceiptCoverage } from '../../../models/po-receipt/po-receipt';
import { CURRENCY_LABELS } from '../../../utilities/currency.util';
import { receivedCoverageTooltip } from '../../../utilities/received-coverage.util';
import { ReceivedCoverageModalComponent } from '../../accounts-payable/_modals/received-coverage-modal/received-coverage-modal.component';

/**
 * The "Exceeds received" warning on a document row (#5662) — shared by the payment request and payment
 * screens so the two show it identically. Renders nothing unless the document is over; hovering gives the
 * figures, clicking opens the per-PO explanation.
 *
 * <p>Advice, not a lock: the row stays selectable and the payment post decides.</p>
 */
@Component({
  selector: 'app-received-coverage-tag',
  templateUrl: './received-coverage-tag.component.html',
})
export class ReceivedCoverageTagComponent {
  private readonly modalService = inject(ModalService);
  private readonly translate = inject(TranslateService);

  readonly coverage = input<PoReceiptCoverage | undefined>(undefined);

  readonly exceeds = computed(() => this.coverage()?.exceedsReceived === true);

  // The static labels, not EnumService: that map is empty on a cold cache, and the tooltip would lose its units.
  readonly tooltip = computed(() => receivedCoverageTooltip(this.coverage(), this.translate, CURRENCY_LABELS));

  open(event: Event): void {
    // The tag sits inside a selectable row; a click here explains, it does not toggle the row.
    event.stopPropagation();
    const coverage = this.coverage();
    if (!coverage) return;
    this.modalService.open(ReceivedCoverageModalComponent, { modalClass: 'modal_large' }, { coverage }).subscribe();
  }
}
